import styled from 'styled-components';

import { SecondaryLoadingButton } from 'approot/shared/styles/buttons/buttons';
import Bouncer from 'approot/shared/bouncer/bouncer';

export const VocabularyImageRegenerateButton = styled(
  SecondaryLoadingButton
).attrs({
  type: 'button',
})`
  width: 100%;
`;

export const VocabularyImagePickerBouncer = styled(Bouncer)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
